<template>
  <div class="formMaking-content">
    <el-form class="search-form" ref="reqData" :model="reqData">
      <el-form-item label="表达名称:" prop="username" label-width="80px">
        <el-input
          v-model="reqData.name"
          placeholder="请输入表达名称"
          size="small"
          @keyup.native.enter="getData"
          @blur="getData"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add" plain size="small" class="search-btn">新增表单</el-button>
      </el-form-item>
    </el-form>
    <el-table ref="formTable" :data="tableData" style="width: 100%" border class="formTable">
      <el-table-column prop="name" label="姓名" width="200" align="center"></el-table-column>
      <el-table-column prop="submitUrl" label="提交地址" align="center"></el-table-column>
      <el-table-column prop="list" label="表单内容" align="center">
        <template slot-scope="scope">
          <div class="list">{{scope.row.list}}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagenation :pageparams="pageparams" @handlePage="handlePage"></pagenation>
  </div>
</template>
<script>
import pagenation from "@/components/pagenation.vue";
import api from "@/api/formMaking/index.js";
export default {
  components: { pagenation },
  data() {
    return {
      reqData: {
        name: "",
        rows: 10,
        page: 1
      },
      tableData: [],
      pageparams: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    }
  },
  mounted() {
    this.reqData.activityId = this.id;
    this.getData();
  },
  methods: {
    async getData() {
      let res = await this.$http.get(`${api.formList}`, {
        params: this.reqData
      });
      if (res && res.isSucceed) {
        this.tableData = res.rows;
        this.pageparams.total = res.total;
      }
    },
    // 翻页
    handlePage(val) {
      this.reqData.page = val;
      this.getData();
    },

    add() {
      this.$router.push("/platformConfig/formMaking/add");
    },
    handleEdit(index, row) {
      this.$router.push({
        path: "/platformConfig/formMaking/add",
        query: {id:row.id}
      });
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该表单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        let res = await this.$http.post(
          api.deleteForm,
          this.$qs.stringify({ id: row.id })
        );
        if (res && res.isSucceed) {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.getData();
        }
      });
    }
  }
};
</script>
<style lang='less' scoped>
.formMaking-content {
  padding: 20px;
  .formTable {
    margin-bottom: 20px;
  }

  .list {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
<style lang='less'>
.formMaking-content {
  .search-form {
    .el-form-item__content {
      text-align: left;
    }
    .el-form-item {
      margin-bottom: 15px;
    }

    .el-input {
      width: 200px;
    }
  }
}
</style>